import type { DetailedHTMLProps, HTMLAttributes } from "react";

export const MarkdownCode = (
  props: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>,
) => {
  return <code className="bg-balder-surface-tinted">{props.children}</code>;
};
